import { useState } from 'react';
import { AlternativeGroup } from '../components/discovery/listingGroups';

/**
 * Which spec chip the buyer is looking at on one BOM line: '' for the line's
 * own spec (the default), or an alternative's specGroup — a read-only preview.
 *
 * The choice belongs to the line as it reads now (`lineSignature`): once the
 * line switches spec, or the chosen alternative is gone, the view falls back to
 * the line's own spec, so the list shows the new spec without a stale preview.
 */
export const useSpecPreview = (alternatives: AlternativeGroup[], lineSignature: string, initialSpecGroup = '') => {
  const [choice, setChoice] = useState<{ specGroup: string; line: string }>({ specGroup: initialSpecGroup, line: lineSignature });
  const stillThere = alternatives.some((a) => a.specGroup === choice.specGroup);
  const specGroup = choice.line === lineSignature && stillThere ? choice.specGroup : '';
  const preview = alternatives.find((a) => a.specGroup === specGroup) ?? null;
  return {
    specGroup,
    /** The alternative being previewed; null on the line's own spec. */
    preview,
    choose: (next: string) => setChoice({ specGroup: next, line: lineSignature }),
  };
};
